import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
// @mui
import { Box, Stack, Drawer, Grid, IconButton } from '@mui/material';
import Iconify from 'src/components/iconify/Iconify';
// hooks
import useResponsive from '../../../hooks/useResponsive';
// config
import { NAV } from '../../../config-global';
// components
import {Logo} from '../../../components/logo';
import Scrollbar from '../../../components/scrollbar';
import { NavSectionVertical } from '../../../components/nav-section';
//
import navConfig from './config-navigation';
// import NavDocs from './NavDocs';
  import NavAccount from './NavAccount';
import NavToggleButton from './NavToggleButton';
import { useNavigate } from 'react-router-dom';
import { Button } from '@mui/material';
import { PATH_AUTH } from 'src/routes/paths';
// ----------------------------------------------------------------------

type Props = {
  openNav: boolean;
  onCloseNav: VoidFunction;
};

export default function NavVertical({ openNav, onCloseNav }: Props) {
  const { pathname } = useLocation();

  const isDesktop = useResponsive('up', 'lg');
  const navigate = useNavigate();

  const handleViewCompanies = () => {
    console.log('Viewing companies');
    navigate(PATH_AUTH.company.list);
  };
  useEffect(() => {
    if (openNav) {
      onCloseNav();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  const renderContent = (
    <Scrollbar
      sx={{
        height: 1,
        '& .simplebar-content': {
          height: 1,
          display: 'flex',
          flexDirection: 'column',
        },
      }}
    >
      <Stack
        spacing={3}
        sx={{
          pt: 3,
          pb: 2,
          px: 2.5,
          flexShrink: 0,
        }}
      >
        <Grid container >
          <Grid container item xs={12} md={12} lg={12} xl={12} alignItems="center" justifyContent="flex-start">
            
            <Grid item lg="auto" md={9.5} sm={9.5} xs={9.5}   >
            <Logo />
            </Grid>

            <Grid item xs="auto" md="auto" lg="auto" xl="auto" display={isDesktop ? 'none' : 'flex'}>
              
              <IconButton onClick={onCloseNav} sx={{ color: 'text.primary'}}>
                <Iconify icon="solar:arrow-right-broken" width={25}/>
        </IconButton>
            </Grid>
            
          </Grid>
        </Grid>

        <NavAccount />
      </Stack>

       <Box sx={{mb:2, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Button variant="contained" color="primary" onClick={handleViewCompanies}>Broker/ Client Companies</Button>
        </Box>
      <NavSectionVertical data={navConfig} />


      <Box sx={{ flexGrow: 1 }} />

      {/* <NavDocs /> */}
    </Scrollbar>
  );

  return (
    <Box
      component="nav"
      sx={{
        flexShrink: { lg: 0 },
        width: { lg: NAV.W_DASHBOARD },
      }}
    >
      <NavToggleButton />

      {isDesktop ? (
        <Drawer
          open
          variant="permanent"
          PaperProps={{
            sx: {
              zIndex: 0,
              width: NAV.W_DASHBOARD,
              bgcolor: 'transparent',
              borderRightStyle: 'dashed',
            },
          }}
        >
          {renderContent}
        </Drawer>
      ) : (
        <Drawer
          open={openNav}
          onClose={onCloseNav}
          ModalProps={{
            keepMounted: true,
          }}
          PaperProps={{
            sx: {
              width: NAV.W_DASHBOARD,
            },
          }}
        >
          {renderContent}
        </Drawer>
      )}
    </Box>
  );
}
